import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import {NgForOf} from '@angular/common';

@Component({
  selector: 'app-select-dropdown',
  imports: [
    NgForOf
  ],
  templateUrl: './select-dropdown.component.html',
  styleUrl: './select-dropdown.component.scss',

})
export class SelectDropdownComponent {

  @Input() label: string = '';
  @Input() options: { value: string, label: string }[] = [];
  @Input() placeholder: string = 'Select an option';
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() value: string = '';

  @Output() valueChange = new EventEmitter<string>();
  @Output() selectionChange = new EventEmitter<string>();

  onSelectChange(event: any) {
    const newValue = event.target.value;
    this.value = newValue;
    this.valueChange.emit(newValue);
    this.selectionChange.emit(newValue);
  }
}
